<template>
  <div>
      <div>
        <div>
          <div style="margin: 2em 0 1em; width: 100%; min-height: 100hv; display: flex; align-items: center; flex-direction: column;">
            <a style="width: 40%;" href="https://lawyerly.ph"><img src="img/lawyerly-invert.logo.png" style="width: 100%; margin: 1em auto;" /></a>
            <!-- <div style="margin: 0 1em;">
              <p>Thank you for registering! You are currently using the free version of <b>Lawyerly</b>. Your free version is equipped with essential tools and features for you to enjoy.</p> 
              <p>If you love using <a style="width: 40%; text-decoration: none;" href="https://lawyerly.ph"><b>Lawyerly</b></a>, subscribe and unlock more powerful features. By subscribing, you will also be helping us improve the app and develop more features for you to enjoy.</p>
            </div> -->
            <!-- <h4>Login Form</h4> -->
          </div>

          <div class="subscribe-mobile">
            <div class="custom-segment">
              <div :class="getStyle('free')" @click="current = 'free'">
                FREE
                <ion-ripple-effect></ion-ripple-effect>
              </div>
              <div :class="getStyle('premium')" @click="current = 'premium'">
                PREMIUM
                <ion-ripple-effect></ion-ripple-effect>
              </div>
            </div>

            <div class="free" v-if="current == 'free'">
              <div v-for="f in features" :key="f.title" style="width: 100%; margin: 1em auto;">
                  <ion-row v-if="f.free">
                      <ion-col style="padding: 0 1em;">
                          <b>{{f.title}}</b><br/>
                          <span v-html="f.description"></span>
                      </ion-col>
                  </ion-row>
              </div>
              <div style="width: 100%; margin: 1em auto;">
                  <ion-row>
                      <ion-col style="padding: 0 1em;">
                          <b>Annotate Supreme Court Rulings and Create Digests</b><br/>
                          <span>Annotate Cases with Fact, Issues, Rulings and Principles to Create Digests.</span>
                      </ion-col>
                  </ion-row>
              </div>
              <div style="width: 100%; margin: 1em auto;">
                  <ion-row>
                      <ion-col style="padding: 0 1em;">
                          <b>LIMITED TO 300 CASES</b><br/>
                      </ion-col>
                  </ion-row>
              </div>
              <div style="width: 100%; margin: 1em auto;">
                  <ion-row>
                      <ion-col>
                        <ion-button expand="block" @click="free">FREE</ion-button>
                      </ion-col>
                  </ion-row>
              </div>
            </div>

            <div class="free" v-if="current == 'premium'">
              <div v-for="f in features" :key="f.title" style="width: 100%; margin: 1em auto;">
                  <ion-row v-if="f.premium && !f.mobile">
                      <ion-col style="padding: 0 1em;">
                          <b>{{f.title}}</b><br/>
                          <span v-html="f.description"></span>
                      </ion-col>
                  </ion-row>
              </div>
              <div v-for="f in features" :key="f.title" style="width: 100%; margin: 1em auto;">
                  <ion-row v-if="f.premium && f.mobile && $config.mobile">
                      <ion-col style="padding: 0 1em;">
                          <b>{{f.title}}</b><br/>
                          <span v-html="f.description"></span>
                      </ion-col>
                  </ion-row>
              </div>
              <div style="width: 100%; margin: 1em auto;">
                  <ion-row>
                      <ion-col style="padding: 0 1em;">
                          <b>Annotate Supreme Court Rulings and Create Digests</b><br/>
                          <span>Annotate Cases with Fact, Issues, Rulings and Principles to Create Digests.</span>
                      </ion-col>
                  </ion-row>
              </div>
              <div style="width: 100%; margin: 1em auto;">
                  <ion-row>
                      <ion-col>
                        <ion-button expand="block" @click="()=>{open()}">&#8369; 500/month</ion-button>
                      </ion-col>
                  </ion-row>
              </div>
            </div>
          </div>

          <div class="subscribe-web">
            <div style="width: 100%; margin: auto; min-width: 750px;">
                <ion-row>
                    <ion-col size-md="4" size-lg="4" size-xs="4">
                        <h6>Features</h6>
                    </ion-col>
                    <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                        <h5>Free</h5>
                    </ion-col>
                    <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                        <h5>Premium</h5>
                    </ion-col>
                </ion-row>
            </div>
            <div v-for="f in features" :key="f.title" style="width: 100%; margin: 1em auto; min-width: 750px;">
                <ion-row v-if="!f.mobile">
                    <ion-col size-md="4" size-lg="4" size-xs="4">
                        <b>{{f.title}}</b><br/>
                        <span>{{f.description}}</span>
                    </ion-col>
                    <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                      <ion-icon size="large" :name="f.free ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    </ion-col>
                    <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                      <ion-icon size="large" :name="f.premium ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    </ion-col>
                </ion-row>
                <ion-row v-if="$config.mobile && f.mobile">
                    <ion-col size-md="4" size-lg="4" size-xs="4">
                        <b>{{f.title}}</b><br/>
                        <span v-html="f.description"></span>
                    </ion-col>
                    <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                      <ion-icon size="large" :name="f.free ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    </ion-col>
                    <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                      <ion-icon size="large" :name="f.premium ? 'checkmark-circle' : 'close-circle'"></ion-icon>
                    </ion-col>
                </ion-row>
            </div>
              <div style="width: 100%; margin: 1em auto; min-width: 750px;">
                  <ion-row>
                      <ion-col size-md="4" size-lg="4" size-xs="4">
                          <b>Create Digests</b><br/>
                          <span>Digest actual cases just by highlighting Facts, Issues, Ruling, and Principles. You’ll discover reviewing cases will be faster with your digests</span>
                      </ion-col>
                      <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                          <h5>LIMITED TO<br/>300 CASES</h5>
                      </ion-col>
                      <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                          <h5>UNLIMITED</h5>
                      </ion-col>
                  </ion-row>
              </div>
                <!-- <div style="width: 100%; margin: 1em auto; min-width: 750px;">
                    <ion-row>
                        <ion-col size-md="4" size-lg="4" size-xs="4">
                          
                        </ion-col>
                        <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                            <ion-button @click="free">FREE</ion-button>
                        </ion-col>
                        <ion-col align-self-center size-md="4" size-lg="4" size-xs="4" text-center>
                            <ion-button @click="()=>{open()}">&#8369; 500/month</ion-button>
                        </ion-col>
                    </ion-row>
                </div> -->
            </div>
          </div>
      </div>

      <div v-if="popupContent">
        <div style="background: #fff;">
          <div id="popupMenu" style="display:none">
              <div class="sub-popup">
                <p>Choose one of our plans:</p>
                <ion-row class="sub-buttons">
                  <ion-col v-for="p in plans" :key="p.label" size-md="4" size-lg="4" size-xs="12" justify-center>
                    <button @click="select(p.type)">
                      <div>
                        <h3 v-html="p.label"></h3>
                        <h4>&#8369; {{p.price}}</h4>
                      </div>
                    </button>
                  </ion-col>
                </ion-row>
              </div>
          </div>
        </div>
      </div>

  </div>
</template>
<script>
import cache from "@/store/cachedState";

export default {
  data() {
    return {
      popupContent: false,
      features: [
        {title: "Search through Supreme Court Rulings", description: "Find Supreme Court Rulings by Case Number, Case Titles or even Key Words or Principles.", free: true, premium: true},
        {title: "Search through laws and their updates", description: "Look up laws and their updates and revisions.", free: true, premium: true},
        {title: "Create Casebooks", description: "Compile cases with similar relevance into casebooks. Add your own notes.", free: true, premium: true},
        // {title: "Share and View shared digests", description: "Share your created digests and find other users’ shared digests.", free: true, premium: true},
        {title: "Share Casebooks", description: "Collaborate with other premium subscribers and share casebooks. Premium subscribers also have the option to keep their casebooks private.", free: false, premium: true},
        {title: "Mobile App", description: "Get exclusive access to the Lawyerly mobile app. Enable faster loading speeds with our mobile app.", free: false, premium: true, mobile: true},
        {title: "Also available SOON for premium subscribers:", description: "<b>Offline Mode</b>. Only available on the mobile app; maintain access to the Lawyerly library even without an internet connection.", free: false, premium: true, mobile: true}
      ],
      plans: this.$config.plans,
      current: "free"
    }
  },

  methods: {
    getStyle(col) {
      if(col == this.current) {
        return [ "item","active", "ion-activatable"];
      } else {
        return [ "item", "ion-activatable"];
      }
    },
    open(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          cssClass: "mobile-wide-width-popup",
          translucent: true
        });
      }, 200);
    },
    free() {
      cache.save("notice-shown", true);
      this.$router.push("/");
    },
    select(type) {
        this.$ionic.dismissPopover();
        this.$router.push("/payment/"+type);
    }
  },

  mounted() {
    const segments = document.querySelectorAll('ion-segment')
    for (let i = 0; i < segments.length; i++) {
      segments[i].addEventListener('ionChange', (ev) => {
        this.current = ev.detail.value;
      })
    }
  }
};
</script>

<style scoped>
  ion-button {
    color: #fff !important;
  }
  ion-icon[name="checkmark-circle"] {
    color: #18bc9c;
  }

  ion-icon[name="close-circle"] {
    color: #ff5858;
  }

  .sub-popup {
    padding: 1.25em 1em;
    width: 100%;
  }

  .sub-buttons {
    display: flex;
    width: 100%;
  }

  .sub-buttons ion-col {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }

  .sub-buttons button:before{
    content:'';
    float:left;
    padding-top:100%;
  }

  .sub-buttons button div{
   height: 100%;
  }

  .sub-buttons button {
    margin: 4px;
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--ion-color-primary);
    max-width: 200px;
  }

  .sub-buttons button div h3, .sub-buttons button div h4 {
    color: #ffffff;
    margin: 0 0 5px 0;
  }

  .sub-buttons button div h4 {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .subscribe-web {
    display: none;
    overflow: auto;
    margin: 0 1em;
  }

  .subscribe-mobile {
    margin: 0 0.5em;
    /* border: solid 2px var(--ion-color-primary); */
  }

  /* .subscribe-mobile .free {
    border-top: solid 1px rgba(0,0,0,0);
    border-left: solid 1px var(--ion-color-primary);
    border-right: solid 1px var(--ion-color-primary);
    border-bottom: solid 1px var(--ion-color-primary);
  } */

  @media (min-width: 800px) {
    .subscribe-mobile {
      display: none;
    }

    .subscribe-web {
      display: block;
    }

    .sub-buttons button {
      margin: 4px;
      width: 100%;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--ion-color-primary);
      max-width: none;
    }
  }

  .custom-segment {
    display: flex;
    width: 100%;
  }

  .custom-segment .item{
    flex: 1;
    padding: 1em 0;
    text-align: center;
    font-weight: 600;
  }

  .custom-segment .item.active{
    color: var(--ion-color-primary);
    border-bottom: 3px solid var(--ion-color-primary);
  }

  .ion-activatable {
    position: relative;
    overflow: hidden;
  }
</style>
